import { hidePageLoad, showPageLoad } from '../../../modules/actions'
import { customAxios as axios, getToken } from '../../../request'
import { notification } from 'antd'
import {
  AddHeadTypeUrl,
  AddUniversityHeadUrl,
  getAllHeadCategoryUrl,
  getAllUniversityHeadUrl, getUniversityListUrl,
  headTypeListUrl, updateUniversityHeadUrl
} from '../apis'

export const addHeadTypeFxn = (valData) => async (dispatch) => {
  dispatch(showPageLoad())
  let { data } = await axios.post(AddHeadTypeUrl(), valData, getToken())
  dispatch(hidePageLoad())
  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  } else {
    notification.success({
      message: data.message || 'Success'
    })
  }
  return data
}

export const listAllHeadTypeFxn = filters => async dispatch => {
  dispatch(showPageLoad())
  let config = {
    params: { ...filters },
    ...(await getToken())
  }
  let { data } = await axios.get(headTypeListUrl(), config)
  dispatch(hidePageLoad())

  return data
}


export const getAllHeadCategoryFxn = filters => async dispatch => {
  dispatch(showPageLoad())
  let config = {
    params: { ...filters },
    ...(await getToken())
  }
  let { data } = await axios.get(getAllHeadCategoryUrl(), config)
  dispatch(hidePageLoad())

  return data
}

export const addUniversityHeadFxn = (valData) => async (dispatch) => {
  dispatch(showPageLoad())
  let { data } = await axios.post(AddUniversityHeadUrl(), valData, getToken())
  dispatch(hidePageLoad())
  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  } else {
    notification.success({
      message: data.message || 'Success'
    })
  }
  return data
}

export const listAllUniversityHeadFxn = filters => async dispatch => {
  dispatch(showPageLoad())
  let config = {
    params: { ...filters },
    ...(await getToken())
  }
  let { data } = await axios.get(getUniversityListUrl(), config)
  dispatch(hidePageLoad())

  return data.data
}

export const getAllUniversityHeadFxn = filters => async dispatch => {
  let config = {
    params: { ...filters },
    ...await getToken()
  }
  let { data } = await axios.get(getAllUniversityHeadUrl(), config)
  return data.data
}

export const updateUniversityHeadFxn = (valData) => async (dispatch) => {
  dispatch(showPageLoad())
  let { data } = await axios.post(updateUniversityHeadUrl(), valData, getToken())
  dispatch(hidePageLoad())
  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  } else {
    notification.success({
      message: data.message || 'Success'
    })
  }
  return data
}
